<div class="container">
  <h1><b>Admin debug page</b>
  @if (selectedStore) {
    <a routerLink="/stores/{{selectedStore.slug}}" class="btn btn-light btn-sm">
      < Back to {{ selectedStore.name }}
    </a>
  }
</h1>

<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link pointer" [ngClass]="{'active': tabs.PREDICTION === activeTab}" (click)="activeTab = tabs.PREDICTION">
      Prediction tasks
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link pointer" [ngClass]="{'active': tabs.OPTIMISATION === activeTab}" (click)="activeTab = tabs.OPTIMISATION">
      Optimisation tasks
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link pointer" [ngClass]="{'active': tabs.JOBS === activeTab}" (click)="activeTab = tabs.JOBS">
      Job definition and logs
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link pointer" [ngClass]="{'active': tabs.ITRENT === activeTab}" (click)="activeTab = tabs.ITRENT">
      iTrent data
    </a>
  </li>
</ul>

@if (activeTab === tabs.PREDICTION) {
  <app-admin-prediction-tasks class="container mt-4"></app-admin-prediction-tasks>
}
@if (activeTab === tabs.OPTIMISATION) {
  <app-admin-optimisation-tasks class="container mt-4"></app-admin-optimisation-tasks>
}
@if (activeTab === tabs.JOBS) {
  <app-admin-job-definition class="container mt-4"></app-admin-job-definition>
  <app-admin-jobs class="container mt-4"></app-admin-jobs>
}
@if (activeTab === tabs.ITRENT) {
  <app-admin-synchronize class="container mt-4"></app-admin-synchronize>
  <app-debug-itrent-employee class="container mt-4 mb-2"></app-debug-itrent-employee>
  <app-debug-itrent-absences class="container mt-4 mb-2"></app-debug-itrent-absences>
  <app-debug-itrent-position class="container mt-4 mb-2"></app-debug-itrent-position>
  <app-debug-itrent-daily-patterns class="container mt-4 mb-2"></app-debug-itrent-daily-patterns>
}
</div>
